import React from 'react';

const Logo = ({ className = "h-10 w-auto", variant = "default" }) => {
  // Using the latest MedQuore logo - maintaining original colors
  const logoSrc = "https://customer-assets.emergentagent.com/job_meddevice-pro/artifacts/1zp9rjco_MedQuoreLogo_No-Background.png";
  
  return (
    <img 
      src={logoSrc} 
      alt="MedQuore" 
      className={className}
      style={{ 
        objectFit: 'contain',
        objectPosition: 'left center'
      }}
    />
  );
};

export default Logo;